import { Collapsible, Select } from "@tredespace/ui/widgets";
import type { JSX } from "react";
import { setDeckMode, setHatchBay, setPlankFam } from "../../state/generator/generator.actions.ts";
import { generatorState } from "../../state/generator/generator.state.ts";
import { Field } from "./Field.tsx";
import { DECK_MODES, PLANK_FAMILIES, toDeckMode, toPlankFamily } from "./generatorOptions.ts";

export function DeckingSection(): JSX.Element {
  const { deckMode, plankFam, hatchBay, numBays } = generatorState.use();
  const hatchOptions = [
    { value: "-1", label: "None" },
    ...Array.from({ length: numBays }, (_, index) => ({
      value: String(index),
      label: `Bay ${index + 1}`,
    })),
  ];

  return (
    <Collapsible title="Decking" defaultOpen>
      <div className="flex flex-col gap-2">
        <Field label="Decked lifts">
          <Select
            value={deckMode}
            onChange={(value) => value && setDeckMode(toDeckMode(value))}
            options={DECK_MODES.map((entry) => ({ value: entry.value, label: entry.label }))}
          />
        </Field>
        <Field label="Plank">
          <Select
            value={plankFam}
            onChange={(value) => value && setPlankFam(toPlankFamily(value))}
            options={PLANK_FAMILIES.map((entry) => ({ value: entry.value, label: entry.label }))}
          />
        </Field>
        <Field label="Access bay">
          <Select
            value={String(hatchBay)}
            onChange={(value) => value && setHatchBay(Number(value))}
            options={hatchOptions}
          />
        </Field>
      </div>
    </Collapsible>
  );
}
